import { RoleName } from '@marageti/z4-sdk/lib/auth';
import { useAuthStore } from '../store';

const useIsAdmin = (): boolean => {
  const { loggedInTeamMember } = useAuthStore();
  return loggedInTeamMember?.userInfo?.[0].roles?.includes(RoleName.ADMIN) || false;
};

export default useIsAdmin;
